module.exports = __webpack_public_path__ + "img/logo_dark.6d3442de.png";